export function initSlideCart() {
    const d = document;
    const b = document.body;
    const slide_cart = d.getElementById("slide-cart");
    const close = d.getElementById("slide-cart__close");
    const open = d.getElementById("slide-cart__open");

    close.addEventListener( "click", function() {
        slide_cart.classList.toggle('open');
    });
    
    open.addEventListener( "click", function() {
        slide_cart.classList.toggle('open');
    } );
}